import PropTypes from "prop-types";
import useReservationList from "../hooks/useReservationList";
import ReservationListPanel from "./ReservationListPanel";
import ReservationTable from "./ReservationTable";

/** One reservation tab: loads it once and renders cards on mobile, the table on desktop. */
function ReservationTabContent({ tabKey }) {
    const list = useReservationList(tabKey);

    return (
        <>
            <div className="flex min-w-0 flex-col gap-4 lg:hidden">
                <ReservationListPanel list={list} />
            </div>
            <div className="hidden lg:block">
                <ReservationTable list={list} />
            </div>
        </>
    );
}

ReservationTabContent.propTypes = {
    tabKey: PropTypes.string.isRequired,
};

export default ReservationTabContent;
